import { requestData } from '../request.ts'
// 创建文件夹
export async function createFolder(params) {
    const res = await requestData({
        url: '/folder/v1/create/folder',
        queryParams: params,
        method: 'get',
    })
    return res
}

export async function deleteFolder(params) {
    const res = await requestData({
        url: '/folder/v1/delete/folder',
        queryParams: params,
        method: 'get',
    })
    return res
}
export async function getFolders(params) {
    const res = await requestData({
        url: '/folder/v1/get/folders',
        queryParams: params,
        method: 'get',
    })
    return res
}
export async function updateFolder(params) {
    const res = await requestData({
        url: '/folder/v1/update/folder',
        queryParams: params,
        method: 'get',
    })
    return res
}
// requestData({
//     url: "/fuzzy/search",
//     method: 'post',
//     headersType: "formdata",
//     queryParams: data
// })
